import { TimelineBaseRequest } from '@types';
import { TimelineChangeCounts } from './getTimelineSummary';
import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export enum TimelineGroupingType {
	Day = 'Day',
	Week = 'Week',
	Month = 'Month',
	Year = 'Year'
}

export type TimelineGroupedSummaryChange = TimelineChangeCounts & {
	date: string;
};

export type GetTimelineGroupedSummaryRequest = TimelineBaseRequest & {
	timelineGroupingType: TimelineGroupingType;
};

export type TimelineGroupedSummaryResponse = {
	timelineEnd: string;
	timelineStart: string;
	selectedGrouping: TimelineGroupingType;
	changes: TimelineGroupedSummaryChange[]
};

export const getTimelineGroupedSummary = createGetEndpoint<
	GetTimelineGroupedSummaryRequest,
	TimelineGroupedSummaryResponse
>((request) => `/api/v3/timelines/grouped-summary?${getQueryString(request)}`);
